export const validLevel2Actionable = [
  "Pending Level 2 Review",
  "Pending Payment Level 2 Review",
  "Payment Rejected By Level 2 Reviewer",
  "Returned For Repayment By Level 2 Reviewer",
  "Rejected By Level 2 Reviewer",
  "Returned By Level 2 Reviewer",
];

export const validLevelTwoStatuses = [
  "Pending Level 2 Review",
  "Pending Payment Level 2 Review",
  "Pending Payment",
  "Payment Rejected By Level 2 Reviewer",
  "Returned For Repayment By Level 2 Reviewer",
  "Pending Level 3 Review",
  "Rejected By Level 2 Reviewer",
  "Returned By Level 2 Reviewer",
  "Rejected By Level 3 Reviewer",
  "Returned By Level 3 Reviewer",
];

export const statusesApplicableForPaymentScreen = [
  "Pending Payment Level 2 Review",
  "Payment Rejected By Level 2 Reviewer",
  "Returned For Repayment By Level 2 Reviewer",
];

export function getDocumentTypesByUserType(
  userType?: string,
  govtDocumentType?: string
) {
  switch (userType) {
    case "Engineer": {
      return [
        {
          key: "gov_id_document",
          label: govtDocumentType || "Government ID",
        },
        { key: "document_certificate", label: "Degree Certificate" },
        { key: "licence_certificate", label: "Engineer License Certificate" },
        { key: "registration_fee_receipt", label: "Registration Fee Receipt" },

      ];
    }
    case "Architect": {
      return [
        {
          key: "gov_id_document",
          label: govtDocumentType || "Government ID",
        },
        { key: "document_certificate", label: "Degree Certificate" },
        {
          key: "licence_certificate",
          label: "Architect License Certificate",
        },
      ];
    }
    case "Supervisor": {
      return [
        {
          key: "gov_id_document",
          label: govtDocumentType || "Government ID",
        },
        {
          key: "document_certificate",
          label: "Highest Education Certificate",
        },
        { key: "experience_certificate", label: "Experience Certificate" },
        { key: "registration_fee_receipt", label: "Registration Fee Receipt" },

      ];
    }
    default: {
      return [
        {
          key: "gov_id_document",
          label: govtDocumentType || "Government ID",
        },
      ];
    }
  }
}
